// extracted by mini-css-extract-plugin
export default {"main":"PopUpCard_main__WKHXE","main_top":"PopUpCard_main_top__W-JqJ"};